import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { Link } from '@provider/navigation';
import { useTrackingManager } from '@provider/tracking';
import { Tooltip } from '@ui/kit';
import { triggerEventOnContainerClick } from '@utils/common';
import { useActivityIndicator, Chevron } from '@utils/react';
import { getFavouriteDataQuery } from '../api/get-data.query.js';
import { card, textContainer, heading, bottomWrapper, subHeading, link, linkIcon, throbber } from './_favourite-card.style.js';
import { CardGraphic } from './atom.graphic.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FavouriteCard(props) {
  const ref = useRef(null);
  const tracker = useTrackingManager();
  const favourite = useQuery(getFavouriteDataQuery.useQueryConfig({
    descriptor: props.descriptor
  }));
  const [isNavigating, setNavigating] = useState(false);
  const navigationActivity = useActivityIndicator(isNavigating, {
    delayMs: 250,
    durationMs: 500
  });
  const subheading = favourite.isError ? "Prøv igen senere" : favourite.data?.type === "course" ? favourite.data.revisionTitle : undefined;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      className: card,
      "data-loading": favourite.isPending,
      onClick: evt => {
        setNavigating(true);
        triggerEventOnContainerClick({
          ref,
          ignores: ["a", "button"],
          triggerSelector: "[data-link-trigger='true']"
        }, evt);
        tracker.trackEvent("userarea.navigation.toContent", {
          method: props.context === "frontpage" ? "favourite-card:frontpage" : "favourite-card:userarea-page",
          to: favourite.data?.path ?? "",
          targetType: favourite.data?.type === "course" ? "Course" : "Page"
        });
      },
      children: [/*#__PURE__*/jsx(CardGraphic, {
        descriptor: props.descriptor,
        favourite: favourite.data
      }), /*#__PURE__*/jsxs("div", {
        className: textContainer,
        children: [/*#__PURE__*/jsx("b", {
          className: heading,
          children: favourite.data?.title ?? (favourite.isError ? "Vi kunne ikke indlæse din favorit" : "Indlæser favorit...")
        }), /*#__PURE__*/jsxs("div", {
          className: bottomWrapper,
          children: [subheading && /*#__PURE__*/jsx("span", {
            className: subHeading,
            children: subheading
          }), favourite.data && /*#__PURE__*/jsx(Tooltip, {
            ariaType: "description",
            placement: "top",
            body: `Gå til '${favourite.data.title}'`,
            children: ref => /*#__PURE__*/jsxs(Link, {
              ref: ref,
              className: link,
              href: favourite.data?.path,
              "aria-label": "G\xE5 til favorit",
              "data-link-trigger": true,
              "data-loading": navigationActivity.isActive(),
              children: [/*#__PURE__*/jsx("span", {
                className: cx(linkIcon, !navigationActivity.isActive() && "visible"),
                children: /*#__PURE__*/jsx(Chevron, {
                  size: 7,
                  lineWidth: 2
                })
              }), /*#__PURE__*/jsx("span", {
                className: cx(linkIcon, navigationActivity.isActive() && "visible"),
                children: /*#__PURE__*/jsx("div", {
                  className: throbber
                })
              })]
            })
          })]
        })]
      })]
    })
  );
}

export { FavouriteCard };
//# sourceMappingURL=_favourite-card.js.map
